export default __webpack_public_path__ + "static/media/zine-cover9.fe53a3ef.png";